import { Handle, Position, useNodesData,NodeProps, useInternalNode } from "@xyflow/react";
import PlusIcon from "../icons/icon-plus-outlined.svg";
import MinusIcon from "../icons/icon-minus-outlined.svg";
import ArrowDown from "../icons/ms-icon-arrow-down.svg";
import SearchIcon from "../icons/icon-search.svg";
import { Checkbox, Dropdown, Input, MenuProps, Popover } from "antd";
import { useEffect, useRef, useState } from "react";

function searchInHierarchyWithParents(data: any, searchValue: string): any {
  let result: any = null;

  const isThingMatch =
    data.thingName &&
    data.thingName.toLowerCase().includes(searchValue.toLowerCase());

  const isTraitMatch =
    data.traitName &&
    data.traitName.toLowerCase().includes(searchValue.toLowerCase());

  if (isThingMatch || isTraitMatch) {
    result = { ...data, traits: [] };
  }

  if (data.traits && Array.isArray(data.traits)) {
    const matchingTraits: any[] = [];

    data.traits.forEach((trait: any) => {
      const matchedChild = searchInHierarchyWithParents(trait, searchValue);
      if (matchedChild) {
        matchingTraits.push(matchedChild);
      }
    });

    if (matchingTraits.length > 0) {
      if (!result) {
        result = { ...data, traits: [] };
      }
      result.traits = matchingTraits;
    }
  }

  return result;
}

const ConstructTableData = ({ traits }: any) => {
  // console.log(traits);
  const [active, setActive] = useState(false);
  return traits.type == "thing" ? (
    <>
      <div className="d-flex tree-line-container">
        <div className="tree-line"></div>
        <div className="d-flex data-list-container position-relative flex-column">
          <div className="img-container d-flex gap-10px align-center">
            <img
              src={active ? MinusIcon : PlusIcon}
              className="node-icon"
              onClick={() => setActive(!active)}
            />
            <span className="list-heading">{traits.thingName}</span>
          </div>
          <div
            key={`${Math.random() * 1000}-${Math.random() * 5000}`}
            className={`d-flex tree-line-container ${
              !active ? "hide-children" : ""
            }`}
            onTransitionEnd={(e: any) => {
              if (!active) {
                e.target.classList.add("hidden");
              }
            }}
          >
            <div className="d-flex flex-column">
              {traits.traits.map((node: any, index: any) => (
                <ConstructTableData traits={node} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="d-flex tree-line-container">
        <div className="tree-line"></div>
        <div className="d-flex align-center gap-10px data-list-container position-relative">
          <span className="dot"></span>
          <span className="list-item">{traits.traitName}</span>
        </div>
      </div>
    </>
  );
};

export const TableNode = (node:any) => {
  console.log("The node value is ",node)
  const internalNode = useInternalNode('1');
  console.log("The internal value is ",internalNode)
  const { data, id } = node
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const divRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (divRef.current) {
      console.log(divRef.current.offsetHeight);
      const divHeight = divRef.current.offsetHeight;
      setHeight(divHeight);
    }
  }, [divRef.current]);

  const handleSearch = (event: any) => {
    setSearchValue(event.target.value);
    let filteredData = searchInHierarchyWithParents(data, event.target.value);
    setFilteredData(filteredData);
  };

  return (
    <div className={`data-model-table-container`} ref={divRef}>
      <Handle
        type="target"
        position={Position.Left}
        style={{
          top: "30px",
          width: "20px",
          height: "20px",
          background: `${data.type == "tie" ? "#FFAE37" : "#00B0F0"}`,
          border: "1px solid #6A7377",
        }}
      />

      <div
        className={`data-model-table-content-container ${
          height >= 400 ? "scroll" : ""
        }`}
      >
        <div className="img-container d-flex gap-10px align-center">
          <img src={MinusIcon} className="node-icon" />
          <span className="list-heading">{data.thingName}</span>
          <Popover
            content={
              <Input
                placeholder="Search..."
                value={searchValue}
                onChange={handleSearch}
              />
            }
            trigger={["click"]}
          >
            <img src={SearchIcon} className="node-icon search-icon" />
          </Popover>
        </div>

        {filteredData.traits.map((node: any, index: any) => (
          <ConstructTableData traits={node} key={index} />
        ))}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        style={{
          top: "30px",
          width: "20px",
          height: "20px",
          background: `${data.type == "tie" ? "#FFAE37" : "#00B0F0"}`,
          border: "1px solid #6A7377",
        }}
      />
    </div>
  );
};

const DropDownContruct = ({
  tableOneData,
  tableTwoData,
  setDropDownCount,
  key,
}: any) => {
  const findForeignKey = (data: any) => {
    return data.traits.filter((trait: any) => trait.is_foreign_key);
  };

  const constructDropDownData = (traits: any, isOne: boolean) => {
    return traits.map((item: any, index: number) => {
      return {
        label: (
          <span
            onClick={() =>
              isOne
                ? setSelectedTraitinTableOne(item.traitName)
                : setSelectedTraitinTableTwo(item.traitName)
            }
          >
            {item.traitName}
          </span>
        ),
        key: index.toString(),
      };
    });
  };

  function trimText(text: string, maxLength: number): string {
    if (text.length <= maxLength) {
      return text;
    }

    return text.slice(0, maxLength) + "...";
  }

  const [selectedTraitinTableOne, setSelectedTraitinTableOne] = useState(
    findForeignKey(tableOneData)[0].traitName
  );
  const [selectedTraitinTableTwo, setSelectedTraitinTableTwo] = useState(
    findForeignKey(tableTwoData)[0].traitName
  );

  return (
    <div className="d-flex align-center w-full mt-10px">
      <div className="d-flex align-center rounded-dropdown w-full">
        <Dropdown
          menu={{ items: constructDropDownData(tableOneData.traits, true) }}
          trigger={["click"]}
          arrow={true}
        >
          <span className="dropdown-content">
            {trimText(selectedTraitinTableOne, 20)}{" "}
            <img
              src={ArrowDown}
              width={10}
              height={10}
              className="down-arrow"
            />
          </span>
        </Dropdown>
        <span className="connector-line"></span>
      </div>

      <div className="remove-input d-flex align-center">
        <img
          src={MinusIcon}
          className="node-icon cursor-pointer"
          onClick={() =>
            setDropDownCount((dropdropDownCount: any) => dropdropDownCount - 1)
          }
        />
      </div>
      <div className="d-flex align-center rounded-dropdown w-full">
        <span className="connector-line"></span>
        <Dropdown
          menu={{ items: constructDropDownData(tableTwoData.traits, false) }}
          trigger={["click"]}
          arrow={true}
        >
          <span className="dropdown-content">
            {trimText(selectedTraitinTableTwo, 20)}{" "}
            <img
              src={ArrowDown}
              width={10}
              height={10}
              className="down-arrow"
            />
          </span>
        </Dropdown>
      </div>
    </div>
  );
};

export const EdgePopUp = ({ edgeId }: any) => {
  console.log("the edge id is ", edgeId);
  const table1Id = edgeId.split("-")[0];
  const table2Id = edgeId.split("-")[1];

  const nodesData = useNodesData([table1Id, table2Id]);

  const tableOneData = nodesData[0].data;
  const tableTwoData = nodesData[1].data;

  const [dropDownCount, setDropDownCount] = useState(1);

  return (
    <div className="edge-popup-container d-flex flex-column position-relative">
      <div className="d-flex inner-content">
        <div className="table-left">
          <div className="table-name align-center">
            <div className="table-circle"></div>
            <div className="table-name-text">{`${tableOneData.thingName}`}</div>
          </div>

          <div className="table-relationship-type d-flex">
            <span>Cardinality</span>
            <div className="relationship-type-icon">1</div>
          </div>
        </div>
        <div className="table-right">
          <div className="table-name align-center">
            <div className="table-circle"></div>
            <div className="table-name-text">{`${tableTwoData.thingName}`}</div>
          </div>

          <div className="table-relationship-type d-flex">
            <span>Cardinality</span>
            <div className="relationship-type-icon">M</div>
          </div>
        </div>
      </div>
      <div className="rounded-dropdown-select-cotainer d-flex flex-column align-center">
        {Array.from({ length: dropDownCount }).map((_, index) => (
          <DropDownContruct
            tableOneData={tableOneData}
            tableTwoData={tableTwoData}
            key={index}
            setDropDownCount={setDropDownCount}
          />
        ))}

        <div className="add-input d-flex">
          <img
            src={PlusIcon}
            className="node-icon cursor-pointer"
            onClick={() => setDropDownCount(dropDownCount + 1)}
          />
        </div>
        <div className="check-input-field d-flex align-center">
          <span>Mandatory</span>
          <Checkbox></Checkbox>
        </div>
      </div>
      <div className="edge-popup-dashed-line"></div>
    </div>
  );
};

export const nodeTypes = {
  thing: TableNode,
};
